import axios from 'axios'

async function user_login (login,set_setting,dispatch,data,setOpen,setMessage,add_test,add_tests,setLoading,navigate){

      setLoading(true)

      const log_in = await axios.post(`${process.env.REACT_APP_SERVER_URL}login/`,data).catch(err=>{console.log(err)})

      if (log_in?.status == 200 && log_in?.data.success == true) {

        if (!log_in?.data?.user?.isVerified) {
          navigate("/verify")
        } else {
          const usr = {
            accessToken:log_in?.data.accessToken,
            refreshToken:log_in?.data.refreshToken,
            auth:true,
            email:log_in?.data.user.email,
            nationality:log_in?.data.user?.nationality,
            birthday:log_in?.data.user?.birthday,
            sex:log_in?.data.user?.sex,
            jobs:log_in?.data.user?.jobs,
            tel:log_in?.data.user?.tel,
            position:log_in?.data.user?.position,
            address:log_in?.data.user?.address,
            idCard:log_in?.data.user?.idCard,
            cardType:log_in?.data.user?.cardType,
            card:log_in?.data.user?.card,
            cv:log_in?.data.user?.cv,
            isVerified:log_in?.data.user?.isVerified,
            isUserVerified:log_in?.data.user?.isUserVerified,
            isPremiumExpired:log_in?.data.user.isPremiumExpired,
            organization:log_in?.data?.user?.organization,
            plan:log_in?.data.user.plan,
            profile:log_in?.data.user.picture,
            tests:log_in?.data.user.tests,
            roomId:"",
            last_name:log_in?.data.user.last_name,
            first_name:log_in?.data.user.first_name,
            totalTest:log_in?.data.user.totalTest,
            totalTraining:log_in?.data.user.totalTraining
          }

          const tests = log_in?.data.user.tests

          const index = tests.length - 1

          dispatch(add_tests(log_in?.data.user.tests))
          dispatch(add_test(tests[index]))
          dispatch(set_setting({
            apiKey:log_in?.data?.user?.ApiKey,
            lang:log_in?.data?.user?.lang
          }))

          localStorage.setItem("iTestUser",JSON.stringify(usr))

          dispatch(login(usr));
          setMessage("you are connected")
          setOpen(true)
          setLoading(false)
          navigate("/dashboard")          
        }
      }else{
        setMessage(log_in?.data.message)
        setOpen(true)
        setLoading(false)
      }
}

export default user_login